import { useState, useEffect } from "react";
import ConfirmModal, {
  ConfirmModalProps,
} from "@/components/modals/confirm-modal";
import { setAlertHandler, AlertOptions } from "@/lib/show-alert";

export function Alert() {
  const [isOpen, setIsOpen] = useState(false);
  const [alertOptions, setAlertOptions] = useState<ConfirmModalProps | null>(
    null,
  );

  const handleShowAlert = (options: AlertOptions) => {
    setAlertOptions({
      img: "info",
      cancelText: "Cancel",
      isOpen: true,
      onCancel: handleClose,
      ...options,
      onConfirm: () => {
        options.onConfirm?.();
        handleClose();
      },
    });
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setAlertOptions(null);
  };

  // Register global handler on mount
  useEffect(() => {
    setAlertHandler(handleShowAlert);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return alertOptions && <ConfirmModal {...alertOptions} isOpen={isOpen} />;
}
